import { IClassname } from '@/lib/shared/model/classname';

export const SmokingAllowed = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.1377 20.4824H30.696V25.5941H5.1377V20.4824Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3064 20.4824V25.5941"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.58179 20.4824V25.5941"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.97146 6.42578C8.97146 6.92924 8.87229 7.42776 8.67963 7.89289C8.48696 8.35803 8.20457 8.78065 7.84858 9.13665C7.49258 9.49265 7.06995 9.77504 6.60482 9.9677C6.13969 10.1604 5.64116 10.2595 5.1377 10.2595C4.12093 10.2595 3.1458 10.6634 2.42683 11.3824C1.70787 12.1014 1.30396 13.0765 1.30396 14.0933V16.6491"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5274 8.98145C11.5274 9.99822 11.1235 10.9733 10.4045 11.6923C9.68552 12.4113 8.71039 12.8152 7.69361 12.8152C6.67684 12.8152 5.70171 13.2191 4.98274 13.9381C4.26377 14.657 3.85986 15.6322 3.85986 16.6489"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
